import React, {useEffect} from 'react'
import '../App.css';
import { FiCommand } from "react-icons/fi";
import { useStyles } from '../Components/useStyles';
import { Grid, TextField, Divider} from '@material-ui/core';
import ReCAPTCHA from "react-google-recaptcha";

export default function ConfirmationPage({studentID, registrationID, appliedProgram, firstChoice, secondChoice, thirdChoice, siblingStudentID, twinID, tripletID, 
    applicantDOB, applicantFirstName, applicantLastName, siblingDOB, siblingFirstName, siblingLastName, twinDOB, twinFirstName, twinLastName, tripletDOB, tripletFirstName, tripletLastName,
     captchaRef, confirmationRef, Paremail, ParphoneNo, ParparentFirstName, ParparentLastName }) {

     const classes = useStyles();
     let load = false;

     const [phoneNo, setPhoneNo] = React.useState(ParphoneNo);
     const [parentFirstName, setParentFirstName] = React.useState(ParparentFirstName);
     const [parentLastName, setParentLastName] = React.useState(ParparentLastName);
     const [email, setEmail] = React.useState(Paremail);

     useEffect(() => {
        load = true;
        confirmationRef.current = {phoneNo:ParphoneNo, parentFirstName:ParparentFirstName, parentLastName:ParparentLastName, email:Paremail};
     },[]);

     useEffect(() => {
        if(!load)
            confirmationRef.current = {phoneNo, parentFirstName, parentLastName, email};
        else 
            load = false;

     },[phoneNo, parentFirstName, parentLastName, email]);

    const regexp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    return (
        <>
                    <h1 className='Title-settings'>Summary</h1>
                    <p></p>
                    <p></p>
                    <h4 className='Title3-settings'>Please review the application information below to ensure it is accurate and complete</h4>
                    <Divider/>
                    <h3 className='Title2-settings'>Student Information</h3>
                    <div >
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_ID"
                                    label={studentID === 0 || studentID ===null ? 'Registration ID' : 'Pupil Number'}
                                    defaultValue={studentID === 0 || studentID ===null ? registrationID : studentID}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_DOB"
                                    label={'Date Of Birth'}
                                    defaultValue={applicantDOB}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_FirstName"
                                    label={'First Name'}
                                    defaultValue={applicantFirstName}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_LastName"
                                    label={'Last Name'}
                                    defaultValue={applicantLastName}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Divider/>
                        <h3 className='Title2-settings'>Applying to:</h3>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_appliedProg"
                                    label={'Applying program'}
                                    defaultValue={appliedProgram}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_firstChoice"
                                    label={appliedProgram === 'EFI' ? 'EFI Catchment School' : appliedProgram === 'LFI' ? 'LFI Catchment School' : 'First Choice'}
                                    defaultValue={firstChoice}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_secondChoice"
                                    label={'Second Choice'}
                                    defaultValue={secondChoice === 0 || secondChoice === '' || secondChoice === null ? 'Not specified' : secondChoice}
                                    className={classes.textField}
                                    disabled={secondChoice === 0 || secondChoice === '' || secondChoice === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid> 
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_thirdChoice"
                                    label={appliedProgram === 'LFI' ? null : 'Third Choice'}
                                    defaultValue={appliedProgram === 'LFI' ? null : thirdChoice === 0 || thirdChoice === '' || thirdChoice === null ? 'Not specified' : thirdChoice}
                                    className={appliedProgram === 'LFI' ? null : classes.textField}
                                    disabled={appliedProgram === 'LFI' ? true : thirdChoice === 0 || thirdChoice === '' || thirdChoice === null ? true : false}
                                    margin="normal"
                                    InputProps={appliedProgram === 'LFI' ? { type: 'hidden' } : {
                                    readOnly: true,
                                    }}
                                />
                            </Grid>         
                        </Grid>
                        <Divider/>
                        <h3 className='Title2-settings'>Sibling Information</h3>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_siblingStudentID"
                                    label={"Sibling's ID number"}
                                    defaultValue={siblingStudentID === 0 || siblingStudentID === '' || siblingStudentID === null ? 'Not specified' : siblingStudentID}
                                    className={classes.textField}
                                    disabled={siblingStudentID === 0 || siblingStudentID === '' || siblingStudentID === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid> 
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_siblingStudentDOB"
                                    label={"Sibling's DOB"}
                                    defaultValue={siblingDOB===''|| siblingDOB===null ? 'Not specified' : siblingDOB}
                                    className={classes.textField}
                                    disabled={siblingDOB === 0 || siblingDOB === '' || siblingDOB === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>

                            <Grid item xs>
                                <TextField
                                    id="txt_summary_siblingStudentFirstName"
                                    label={"Sibling's First Name"}
                                    defaultValue={siblingFirstName===''|| siblingFirstName===null ? 'Not specified' : siblingFirstName}
                                    className={classes.textField}
                                    disabled={siblingFirstName === 0 || siblingFirstName === '' || siblingFirstName === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_siblingStudentLastName"
                                    label={"Sibling's Last Name"}
                                    defaultValue={siblingLastName===''|| siblingLastName===null ? 'Not specified' : siblingLastName}
                                    className={classes.textField}
                                    disabled={siblingLastName === 0 || siblingLastName === '' || siblingLastName === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Divider/>
                        <h3 className='Title2-settings'>Twin Information</h3>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_twinID"
                                    label={studentID === 0 || studentID ===null ? "Twin Registration ID" : "Twin Pupil Number"}
                                    defaultValue={twinID === 0 || twinID === '' || twinID === null ? 'Not specified' : twinID}
                                    className={classes.textField}
                                    disabled={twinID === 0 || twinID === '' || twinID === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>  
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_twinDOB"
                                    label={"Twin's DOB"}
                                    defaultValue={twinDOB===''|| twinDOB===null ? 'Not specified' : twinDOB}
                                    className={classes.textField}
                                    disabled={twinDOB === 0 || twinDOB === '' || twinDOB === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_twinFirstName"
                                    label={"Twin's First Name"}
                                    defaultValue={twinFirstName === '' || twinFirstName === null ? 'Not specified' : twinFirstName}
                                    className={classes.textField}
                                    disabled={twinFirstName === 0 || twinFirstName === '' || twinFirstName === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid> 
                            <Grid item xs>
                                <TextField
                                    id="txt_summary_twinLastName"
                                    label={"Twin's Last Name"}
                                    defaultValue={twinLastName === '' || twinLastName === null ? 'Not specified' : twinLastName}
                                    className={classes.textField}
                                    disabled={twinLastName === 0 || twinLastName === '' || twinLastName === null ? true : false}
                                    margin="normal"
                                    InputProps={{
                                    readOnly: true,
                                    }}
                                />
                            </Grid> 
                        </Grid>
                        <Divider/>
                        <h3 className='Title2-settings'>Declaration and Signature</h3>
                        <Grid container spacing={3}>
                            <Grid item xs>
                            By submitting this form, I declare the above information is true and correct in every respect. I also declare that I am the parent or legal guardian for the student applicant. 
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <TextField 
                                    required 
                                    id="txt_summary_firstname"
                                    label={'Parent/Legal Guardian First Name'}
                                    defaultValue={ParparentFirstName}
                                    className={classes.FulltextField}
                                    margin="normal"
                                    onChange={event=>setParentFirstName(event.target.value)}                         
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    required
                                    id="txt_summary_lastname"
                                    label={'Parent/Legal Guardian Last Name'}
                                    defaultValue={ParparentLastName}
                                    className={classes.FulltextField}
                                    margin="normal"
                                    onChange={event=>setParentLastName(event.target.value)}                   
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <TextField
                                    required
                                    id="txt_summary_email"
                                    label={'Email'}
                                    defaultValue={Paremail}
                                    className={classes.FulltextField}
                                    margin="normal"
                                    onChange={event=>setEmail(event.target.value)}                            
                                    error={email !== '' && email !== null && !regexp.test(email)}                          
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    required
                                    id="txt_summary_phone"
                                    label={'Phone Number'}
                                    defaultValue={ParphoneNo}
                                    className={classes.FulltextField}
                                    margin="normal"
                                    onChange={event=>setPhoneNo(event.target.value)}               
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <ReCAPTCHA
                            ref ={captchaRef}
                            sitekey={process.env.REACT_APP_CAPTCHAKEY}
                        />                  
                    </div>
        </>   
    );
}